// @ts-nocheck
import { alpha, Button } from "@mui/material";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";

const UnderlineButton = ({
  title,
  onClick,
  styles,
  showUnderline,
  disabled = false,
}) => {
  return (
    <Button
      onClick={onClick}
      sx={{
        position: "relative",
        // padding: "0",
        fontSize: styles?.fontSize || "20px",
        color: !disabled
          ? styles?.color ||
            getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })
          : "gray",
        background: alpha(
          getCssVariableHandler({ variableName: "--primary-pink-hex" }),
          0.3,
        ),
        padding: "0.25rem 0.25rem 0 0.25rem",
        border: "none",
        boxShadow: "none",
        cursor: disabled ? "not-allowed" : "pointer",
        "& ::after":
          showUnderline === false
            ? {}
            : {
                content: '""',
                position: "absolute",
                bottom: "0",
                left: "0",
                width: "100%",
                height: "1px",
                background: !disabled
                  ? styles?.underLineColor ||
                    getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })
                  : "gray",
                cursor: disabled ? "not-allowed" : "pointer",
              },
        "&:hover": {
          background: alpha(
            getCssVariableHandler({ variableName: "--primary-pink-hex" }),
            0.5,
          ),
          color: !disabled
            ? styles?.color ||
              getCssVariableHandler({
                variableName: "--white-rgb",
              })
            : "gray",
          border: "none",
          boxShadow: "none",
        },
        ...(styles || {}),
      }}
    >
      {title}
    </Button>
  );
};

UnderlineButton.propTypes = {
  title: PropTypes.node,
  onClick: PropTypes.func,
  styles: PropTypes.object,
  showUnderline: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default UnderlineButton;